import appConfig from './../config/appConfig';
import '../styles/legal-pages.css';

const TermsConditions = () => (
    <div className="pxl-legal-page">

        {/* Header */}
        <header className="pxl-legal-header">
            <div className="pxl-legal-header-inner">
                <a href={appConfig.appUrl} className="pxl-legal-header-logo">
                    <img src={appConfig.appLogo} alt="PixaLab" />
                </a>
                <a href={`${appConfig.appUrl}login`} className="pxl-legal-header-login">Login</a>
            </div>
        </header>

        {/* Hero */}
        <div className="pxl-legal-hero">
            <div className="pxl-legal-hero-badge">Legal</div>
            <h1>Terms &amp; Conditions</h1>
            <p className="pxl-legal-hero-meta">These policies apply to all products and services from PixaLab (app.pixalab.ai)</p>
        </div>

        <div className="pxl-legal-body">

            {/* Hours of Operation */}
            <div className="pxl-legal-section">
                <div className="pxl-legal-section-header">
                    <div className="pxl-legal-section-num">1</div>
                    <h2 className="pxl-legal-section-title">Hours of Operation</h2>
                </div>
                <ul className="pxl-legal-bullets">
                    <li>app.pixalab.ai office is open Monday – Friday, 9 a.m. – 5 p.m. EST.</li>
                    <li>We close for all government-observed holidays.</li>
                </ul>
            </div>

            {/* Returns */}
            <div className="pxl-legal-section">
                <div className="pxl-legal-section-header">
                    <div className="pxl-legal-section-num">2</div>
                    <h2 className="pxl-legal-section-title">Returns &amp; Refunds</h2>
                </div>
                <ul className="pxl-legal-bullets">
                    <li>All refunds will be processed within 7 days of approval.</li>
                    <li>100% money-back guarantee covers the price of the product only.</li>
                    <li>Customers must contact our support department with their order information to request a refund.</li>
                    <li>Once a valid refund request is submitted, the refund process will take no more than 30 days. All refunds will be returned to the original credit card; PayPal orders will be credited back to the PayPal account.</li>
                    <li>You have <strong>30 days</strong> from the date of the original purchase to request a refund. Any request received after the 30-day limit will not be processed.</li>
                    <li>If we receive excessive or repeated refund requests, we reserve the right to add you to our blacklist to prevent future purchases and to deny future refunds if we feel you are taking advantage of our money-back guarantee.</li>
                </ul>
            </div>

            {/* Payment */}
            <div className="pxl-legal-section">
                <div className="pxl-legal-section-header">
                    <div className="pxl-legal-section-num">3</div>
                    <h2 className="pxl-legal-section-title">Payment Methods</h2>
                </div>
                <div className="pxl-legal-note">
                    Checks or "e-checks" will <strong>not</strong> be accepted as a form of payment.
                </div>
            </div>

            {/* Customer Service */}
            <div className="pxl-legal-section">
                <div className="pxl-legal-section-header">
                    <div className="pxl-legal-section-num">4</div>
                    <h2 className="pxl-legal-section-title">Customer Service</h2>
                </div>
                <p>If you have questions or comments regarding our products, please contact us at our support portal:</p>
                <p>
                    <a href="https://support.pixalab.ai/auth/registration" target="_blank" rel="noopener noreferrer">
                        https://support.pixalab.ai/auth/registration
                    </a>
                </p>
            </div>

        </div>

        <footer className="pxl-legal-footer">
            © {new Date().getFullYear()} PixaLab. All rights reserved. &nbsp;·&nbsp; <a href="/privacy-policy" style={{ color: "#7e1acc" }}>Privacy Policy</a>
        </footer>
    </div>
);

export default TermsConditions;
